
export const copyTeamMember = async (functionParameters = {}) => {

    functionParameters.sideMenuItems = window.currentSideMenuItems;
    functionParameters.smetioAppUi = window.currentSmetioAppUi;
    functionParameters.isCopying = true;
    
    const {createNewTeamMember} = (await import(/* webpackPrefetch: true */ "./createNewTeamMember"));

    return createNewTeamMember(functionParameters);

};
